export default __webpack_public_path__ + "static/media/tweet2.8b72af3f.png";